import type { ReactElement } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export interface FilterDrawerItemProps {
  /**
   * Sizing for this filter's slot in the inline (desktop) bar, merged over
   * the default slot sizing. Ignored inside the drawer, where every filter
   * takes the full drawer width.
   */
  inlineSx?: SxProps<Theme>;
  /**
   * Keeps this filter in the bar, at its inline sizing, when the filters
   * collapse into the drawer. A pinned filter applies at once, like an inline
   * one, and is left out of the drawer badge count.
   */
  pinned?: boolean;
  children: ReactElement;
}

/**
 * Marks a `FilterDrawerContainer` child (or its `searchField`) with its own
 * inline sizing, for bars that need to fit more filters on one row than the
 * default slot width allows. Renders its child unchanged.
 */
const FilterDrawerItem = ({ children }: FilterDrawerItemProps) => children;

export default FilterDrawerItem;
